import React, { useEffect, useState } from 'react';

import Button from 'lib/components/button/Button';
import Modal from 'lib/components/modal/Modal';
import Select from 'lib/components/select/Select';

export default function InspectionsExportByDecisionModal({
  isOpen,
  options = [],
  onRequestClose,
  onExport,
}) {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (isOpen) setSelected([]);
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title='Export results by last decision'
      className='inspection-list--export-by-decision-modal'
      data-testid='InspectionsListPage.exportByDecisionModal'
      actions={
        <Button
          disabled={!selected.length}
          onClick={() => onExport(selected.map((option) => option.value))}
          data-testid='InspectionsListPage.exportByDecisionSubmit'
        >
          Export
        </Button>
      }
    >
      <p>
        Only finished inspections whose last decision is one of the selected
        decisions will be exported.
      </p>
      <Select
        isMulti
        isInModal
        isClearable={false}
        isSearchable
        label='Last decision'
        placeholder='Select decisions...'
        options={options}
        value={selected}
        onChange={(value) => setSelected(value || [])}
        data-testid='InspectionsListPage.exportByDecisionSelect'
      />
    </Modal>
  );
}
